import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Icon, Select, Tooltip, Radio, Divider, Alert, DatePicker, Switch, message, Popover, Typography } from 'antd';
import { TransferRequestApproval } from '../../../../models';
import { handleApiExceptions, alertify } from '../../../../app_methods';
import { connect } from 'react-redux';
import _last from 'lodash/last'
import _isEqual from 'lodash/isEqual';
import moment from 'moment';

let ApprovalConfigForm = (props) => {

    const { form, approvalConfig } = props;
    const { getFieldDecorator } = form;
    const validations = TransferRequestApproval.validations;

    const [transferApprovalConfig, setTransferApprovalConfigs] = React.useState(approvalConfig || []);
    const [levels, setLevels] = React.useState([]);

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
//             if (err) return;
            const form_config = form.getFieldValue('transfer_approval_config') || [];
            if(!form_config.every(data => data.approval_by.length != 0 && data.min_txn_amount)){
                message.warning("Please fill Min transaction amount and Levels")
                return;
            }
            if(!form_config.every(data => data.min_txn_amount.match(/^-?\d*(\.\d+)?$/))){
                message.warning("Min transaction amount is invalid.")
                return;
            }
            if(!form_config.every(data => !data.max_txn_amount || data.max_txn_amount.match(/^-?\d*(\.\d+)?$/))){
                    message.warning("Max transaction amount is invalid.")
                    return;
                }
            if(!form_config.every(data => Number(data.min_txn_amount) != 0)){
                message.warning("Min transaction amount cant be 0 ")
                return;
            }
            if(!form_config.every(data => !data.max_txn_amount || Number(data.max_txn_amount) > Number(data.min_txn_amount))){
                message.warning("Max transaction amount should be greater than Min transaction amount.")
                return;
            }
            let flag=false;
            form_config.sort((a, b) => parseFloat(a.min_txn_amount) - parseFloat(b.min_txn_amount));
            for(var i=1; i<form_config.length; i++){
                if(!(form_config[i-1].max_txn_amount) || Number(form_config[i].min_txn_amount )<= Number(form_config[i-1].max_txn_amount)){
                    flag = true;
                    message.warning("Invalid Amount range provided")
                    return
                }
            }
            props.onSubmit({transfer_approval_config: form_config});
        });
    };
    const addConfigRow = () => {
        const form_config = form.getFieldValue('transfer_approval_config') || [];
        if(form_config.constructor.name == 'Object' && transferApprovalConfig.length == 0 ){
            const config = transferApprovalConfig;
            config.push({approval_by: [], max_txn_amount: null, min_txn_amount: null, override: false})
            setTransferApprovalConfigs([...config]);
            return
        }
        else if(form_config.constructor.name == 'Object' && transferApprovalConfig.length != 0 ){
            message.warning("Previous row details are not filled.")
            return
        }
        if(!form_config.every(config => config.approval_by.length != 0 && config.min_txn_amount)){
            message.warning("Previous row details are not filled.")
            return;
        }
        if(!form_config.every(data => data.min_txn_amount.match(/^-?\d*(\.\d+)?$/))){
                message.warning("Min transaction amount is invalid.")
                return;
            }
         if(!form_config.every(data => Number(data.min_txn_amount) != 0)){
                message.warning("Min transaction amount cant be 0 ")
                return;
            }
        if(!form_config.every(data => !data.max_txn_amount || data.max_txn_amount.match(/^-?\d*(\.\d+)?$/))){
                message.warning("Max transaction amount is invalid.")
                return;
            }
        if(!form_config.every(data => !data.max_txn_amount || Number(data.max_txn_amount) > Number(data.min_txn_amount))){
                message.warning("Max transaction amount should be greater than Min transaction amount.")
                return;
            }
        const config = transferApprovalConfig;
        config.push({approval_by: [], max_txn_amount: null, min_txn_amount: null, override: false})
        setTransferApprovalConfigs([...config]);
    }

    const removeConfigRow = (rowIndex) => {
        const form_config = form.getFieldValue('transfer_approval_config') || [];
        if(form_config.constructor.name != 'Object'){
            const obj = form_config.splice(rowIndex, 1);
            form.setFieldsValue({transfer_approval_config: form_config})
        }
        const config = transferApprovalConfig;
        config.splice(rowIndex,1)
        setTransferApprovalConfigs([...config]);
    }

    function handleChange(values) {
      setLevels(values.sort()); // { key: "lucy", label: "Lucy (101)" }
    }



    return (
        <Form onSubmit={onSubmit}>
            <div className="row">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center" style={{float: 'right'}}>
{/*                         <Typography.Text level={4} style={{ fontSize: '14px' }}>Config:</Typography.Text> */}
                        <Button type="link" style={{ paddingRight: 0,  }} icon="plus" onClick={addConfigRow}>Add</Button>
                    </div>
                    <div className="splits mt-2">
                        <table class="table">
                              <thead>
                                <tr>
                                  <th scope="col">Min Amount</th>
                                  <th scope="col">Max Amount</th>
                                  <th scope="col">Levels</th>
                                  <th scope="col">Override</th>
                                  <th scope="col">Action</th>
                                </tr>
                              </thead>
                               <tbody>
                            {
                            (transferApprovalConfig || []).map((config, index) => {
                                return (
                                    <tr>
{/*                                     <div className="mb-2" key={index}> */}
{/*                                         <div className="d-flex justify-content-between w-100 align-items-center"> */}
                                            <td>
                                            {getFieldDecorator(`transfer_approval_config[${index}].min_txn_amount`, {
                                                initialValue: config.min_txn_amount,
                                                rules: validations.amount
                                            })(
                                                <Input autoComplete='off' type="text" placeholder="Min Transaction Amount" />
                                            )}
                                            </td>
                                            <td>
                                            {getFieldDecorator(`transfer_approval_config[${index}].max_txn_amount`, {
                                                initialValue: config.max_txn_amount,
                                                rules: validations.amount
                                            })(
                                                <Input autoComplete='off' type="text" placeholder="Max Transaction Amount" />
                                            )}
                                            </td>
                                            <td>
                                            {getFieldDecorator(`transfer_approval_config[${index}].approval_by`, {
                                                initialValue: config.approval_by.sort(),
                                            })(
                                                <Select style={{width: '300px'}} mode="multiple" allowClear placeholder="Approvals required by" onChange={handleChange} value={levels}>
                                                    {
                                                        ["L1", "L2", "L3", "L4", "L5"].map(level =>
                                                            <Select.Option value={level}>{level}</Select.Option>
                                                        )
                                                    }
                                                </Select>
                                            )}
                                            </td>
                                            <td>
                                            {getFieldDecorator(`transfer_approval_config[${index}].override`, {
                                                initialValue: config.override,
                                                valuePropName: "checked",
                                            })(
                                                <Switch />
                                            )}

                                            </td>
                                            <td>
                                            <Icon type="delete" style={{ fontSize: '150%', color: 'red' }} className="ml-2" onClick={() => removeConfigRow(index)} />
                                            </td>
{/*                                         </div> */}
{/*                                     </div> */}
                                   </tr>
                                )
                            })
                        }
                        </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>Submit</Button>
            </div>
        </Form >
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

ApprovalConfigForm = Form.create()(ApprovalConfigForm);

export default connect(mapStateToProps)(ApprovalConfigForm);